var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.client)?_c('div',[_c('p',{staticClass:"title is-3 oc-client"},[_vm._v(_vm._s(_vm.client.name))]),_vm._v(" "),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/index.vue?vue&type=template&id=40ec22f3&scoped=true
// module id = m8w8
// module chunks = 0